import React from "react";
import axios from "axios";
import { notifications } from '@mantine/notifications';
import { Text, Group } from '@mantine/core';
import { Dropzone } from '@mantine/dropzone';
import heic2any from "heic2any";

import { useLoginContext } from "../../context/loginContext";
import { BE_API_THREE, utils } from "../../utils/globalVariables";

import ModalResponse from "../../components/general/ModalResponse";

// info: MIME TYPE SOLVED
// info: HEIC CONVERTER IN ANOTHER FILE

const SerahTerimaFotoDropper = ({ stateData, fnOnAdded }) => {

    const mountedRef = React.useRef(true);
    const { loginContext, handleSetLoginContext } = useLoginContext();

    const notificationId = React.useRef({
        errorUpload: 'serahTerimaFotoDropper-1',
        errorSubmitData: 'serahTerimaFotoDropper-2',
    })

    const [data, setData] = React.useState({
        submitLoading: false,
        fileUploadingProgress: 0,

        modalResponse: {
            show: false,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: false,
            content: ''
        }
    });

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        }
    }, [])

    const handleFileUpload = async (event) => {
        const file = event;

        setData(d => ({ ...d, submitLoading: true }));

        if (file && file.type === "image/heic") {
            try {
                const convertedBlob = await heic2any({ blob: file, toType: "image/jpeg" });
                const jpegFile = new File([convertedBlob], `${file.name}.jpeg`, { type: "image/jpeg" });
                submitData(jpegFile);
            } catch (error) {
                setData(d => ({ ...d, submitLoading: false }));
                console.error("Konversi HEIC gagal: ", error);
            }
        } else {
            submitData(file);
        }
    }

    const fnOnChangeFile = (e) => {
        if (e[0]) {
            handleFileUpload(e[0]);
        } else {
            notifications.show({
                id: notificationId.current.errorUpload,
                title: utils.notification.warning.caption,
                message: "Uppss.. Sepertinya terjadi kesalahan.",
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: false,
            })
        }
    }

    const fnOnChangeFileError = (e) => {
        Object.keys(e[0].errors).map((key, index) => {
            return (
                notifications.show({
                    id: notificationId.current.errorUpload + '-' + index,
                    title: utils.notification.warning.caption,
                    message: e[0].errors[key].message,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: false,
                })
            )
        })
    }

    const submitData = (stateFile) => {
        // setData(d => ({ ...d, submitLoading: true, }));

        const formDT = new FormData();
        const formDTHeader = { Accept: 'application/json', 'Content-Type': 'multipart/form-data' }

        formDT.append('json_token', loginContext.syswebapp);
        formDT.append('trx_id', stateData.trxId);
        // formDT.append('primary_key_id', stateData.primaryKeyId);
        formDT.append('current_step', stateData.currentStep);
        formDT.append('is_cancel', stateData.isCancel);

        formDT.append('photos[0]', stateFile);
        formDT.append('image_max_size_in_mb', utils.imageMaxSizeUploadFotoInMB);
        formDT.append('file_type_accepted', '');

        // mime types sudah dihandle di BE

        axios({
            method: 'post',
            url: BE_API_THREE + '/add_delivery_jemput_foto_serah_terima',
            data: formDT,
            headers: formDTHeader,
            onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);

                setData(d => ({ ...d, fileUploadingProgress: percentCompleted }))
            }
        }).then((response) => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, submitLoading: false, fileUploadingProgress: 0 }));

            if (response.data.flag_status === 'isset') {
                fnOnAdded(response.data.data);
            }

            if (response.data.flag_status === 'no-data') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: 'Data tidak ditemukan.',
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'invalid-json-token') {
                handleSetLoginContext(null);
            }

            if (response.data.flag_status === 'user-inactive') {
                handleSetLoginContext(null);
            }

            if (response.data.flag_status === 'error') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: 'Error : ' + response.data.pesan,
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'wrong-type') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: `"${response.data.suspect}" tidak sesuai dengan format yang diizinkan (${response.data.allowed}).`,
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'wrong-size') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: `"${response.data.suspect}" melebihi ukuran yang diizinkan (${response.data.max_size}).`,
                        show: true
                    }
                }))
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            setData(d => ({
                ...d,
                submitLoading: false,
            }))

            notifications.show({
                id: notificationId.current.errorSubmitData,
                title: utils.notification.warning.caption,
                message: error.message,
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: true,
            })
        })
    }

    return (
        <React.Fragment>
            <Dropzone
                onDrop={fnOnChangeFile}
                onReject={fnOnChangeFileError}
                maxSize={utils.imageMaxSizeUploadFotoInMB * utils.oneBytesIs}
                accept={['image/*']}
                maxFiles={1}
                disabled={data.submitLoading}
                // {...props}

                mt='md'

                styles={(tema) => ({
                    root: {
                        paddingTop: tema.spacing.xs,
                        paddingBottom: tema.spacing.xs,
                    }
                })}

                sx={(tema) => ({
                    borderWidth: '1px',
                    borderStyle: 'dashed',
                    borderColor: tema.colorScheme === 'light' ? tema.colors.blue[6] : tema.colors.blue[6],
                    borderRadius: tema.radius.sm,
                    color: tema.colorScheme === 'light' ? tema.colors.blue[6] : tema.colors.blue[6],
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: tema.colorScheme === 'light' ? tema.fn.rgba(tema.colors.blue[3], 0.1) : tema.fn.rgba(tema.colors.blue[9], 0.1),
                    }
                })}
            >
                <Group
                    spacing={5}
                    px='xs'
                    position="center"

                    style={{
                        // minHeight: rem(20),
                        pointerEvents: 'none'
                    }}
                >
                    <Dropzone.Accept>
                        <Text size='sm'>Upload</Text>
                    </Dropzone.Accept>

                    <Dropzone.Reject>
                        <Text size='sm'>Ooppss..</Text>
                    </Dropzone.Reject>

                    <Dropzone.Idle>
                        <Text size='sm'>{data.submitLoading ? `Uploading ${data.fileUploadingProgress}%` : 'Click or Drop File Here'}</Text>
                    </Dropzone.Idle>
                </Group>
            </Dropzone>

            <ModalResponse
                stateShow={data.modalResponse.show}
                fnHide={() => setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        show: false
                    }
                }))}

                stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
                stateType={data.modalResponse.type}
                stateContent={data.modalResponse.content}
            />
        </React.Fragment>
    )
}

export default SerahTerimaFotoDropper;